import { createSelector } from 'reselect';
import { FAILED, STARTED } from '../constants/RequestStatusTypes';
import { getForecastTypeFilter } from './filtersSelectors';
export const getDeals = state => {
  return state.deals;
};
export const dealsSelector = createSelector([getDeals], deals => {
  return deals.get('deals');
});
export const getDealsStatus = createSelector([getDeals], deals => {
  return deals.get('status');
});
export const getDealsLoading = createSelector([getDealsStatus], status => {
  return status === STARTED;
});
export const getDealsFetchError = createSelector([getDealsStatus], status => {
  return status === FAILED;
});
export const getDealsTotal = createSelector([getDeals], deals => {
  return deals.get('total');
});
export const getDealsList = createSelector([dealsSelector], deals => {
  return deals.toList();
});
export const getDealsArray = createSelector([dealsSelector], deals => {
  return deals.toArray();
});
export const getTotalDealAmount = state => {
  return state.deals.get('totalDealAmount');
};
export const getTotalOrWeightedDealAmount = state => {
  var _state$deals$get;
  return (_state$deals$get = state.deals.get('totalOrWeightedDealAmount')) !== null && _state$deals$get !== void 0 ? _state$deals$get : {
    currencyCode: '',
    value: 0
  };
};
export const getSelectedDealAmount = state => {
  return state.deals.get('selectedDealAmount');
};
export const getSelectedDealCount = state => {
  return state.deals.get('selectedDealCount');
};
export const getSelectedDealIdsByForecastType = state => {
  return state.deals.get('selectedDealIdsByForecastType');
};
export const getSelectedDealIds = createSelector([getSelectedDealIdsByForecastType, getForecastTypeFilter], (selectedDealIdsByForecastType, forecastTypeId) => {
  return selectedDealIdsByForecastType[forecastTypeId !== null && forecastTypeId !== void 0 ? forecastTypeId : 0] || undefined;
});
export const getShowSubmissionPanelFromDealTable = state => {
  return state.deals.get('showSubmissionPanelFromDealTable');
};
export const getDealColumnWidths = state => {
  return state.deals.get('dealColumnWidths');
};
export const getDealTablePagination = createSelector([getDeals], deals => {
  return deals.get('pagination');
});
export const getDealTableSort = createSelector([getDeals], deals => {
  return deals.get('sort').state;
});
export const getIsDefaultSort = createSelector([getDeals], deals => {
  return deals.get('sort').isDefault;
});